t = require('views/internal/teacup-with-helpers')('org_prefs_restrict_invites')

module.exports = t.renderable ({ hasRestrictions }) ->
  t.div ->
    t.ul ->
      t.li { class: t.classify('team-setting-restriction-group': true) }, ->
        t.ul '.pop-over-list.checkable.green-check', ->
          t.li { class: t.classify(active: !hasRestrictions, 'js-team-admins-can-change': true) }, ->
            t.a { href: '#', class: 'team-admins-can-change' }, ->
              t.format 'let-team-admins-decide'
              t.span { class: 'sub-name' }, ->
                t.format 'team-admins-can-change'
          t.hr()


    t.div { class: t.classify('team-setting-restriction-group': true, 'restriction-form-wrapper': true, disabled: !hasRestrictions) }, ->
      t.div '.pop-over-sub-heading', ->
        t.format 'email-domain-restrictions'

      t.form '.form-grid.js-form', ->

        t.div '.form-grid-child-threequarters.u-relative', ->
          t.input '.js-input-restricted', { type: 'text', placeholder: t.l('add-a-domain-or-address-ellipsis'), style: 'margin-bottom: 6px;' }
          t.span '.spinner.small.hide.js-loading', { style: 'position: absolute; top: 12px; right: 8px; z-index: 2;' }

        t.div '.form-grid-child-quarter', ->
          t.input '.mod-inline-with-text-input.primary.js-form-submit-input', { type: 'submit', value: t.l('add') }

      t.p '.u-bottom.quiet', { style: 'padding: 6px;' }, ->
        t.format 'choose-allowed-domains'

      t.p '.error.u-bottom.js-errors', { style: 'display: none; margin-top: 8px;' }, ->
        t.format 'invalid-domain-or-email-address'

      t.div '.pop-over-section.js-restriction-list', {
        style: t.stylify({
          'margin-top': '16px'
          'display': if hasRestrictions then 'block' else 'none'
        })
      }, ->
        t.h4 ->
          t.format 'allowed-domains-and-addresses'
        t.ul '.closeable-list.js-list'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/ent_org_prefs_restrict_invites.coffee